// Zeplin: Hermes_Landing / Hermes_ResponseStart — decorative dotted grid
// (2px dots, 12px x 10px pitch) behind the page content, on a white base.
export default function DottedBackground() {
  return <div aria-hidden="true" className="tw-pointer-events-none tw-absolute tw-top-3 tw-bottom-3 tw-left-1 tw-right-[18px] tw-bg-[length:12px_10px] tw-bg-[image:radial-gradient(circle_at_1px_1px,#eaecf0_1px,transparent_1.5px)]" />;
}
